module.exports = __webpack_public_path__ + "img/chart-pie.ed425477.svg";